module.exports = __webpack_public_path__ + "img/sxdl.fcad2edd.svg";